import { createFileRoute } from '@tanstack/react-router';
import { PortalLanguagesStepForm } from './-components/portal-new-steps/languages-step';

export const Route = createFileRoute('/ngos/portals/$portalId_/setup/')({
	component: PortalLanguagesStepForm,
});
